import { maybeLocale } from '@wework/universal-locale-utils';
import { varsFromServer } from '../client_side_injection_vars';

export function localizeLink({ to = '/', locale = getLocale() }) {
  const separator = to[0] === '/' ? '' : '/';
  const link = `${maybeLocale(locale)}${separator}${to}`;
  return link;
}

export function getLocale() {
  const DEFAULT_LOCALE = 'en';
  return varsFromServer.locale || DEFAULT_LOCALE;
}

export function getSelectedLocale() {
  return varsFromServer.locale;
}

export function stripOutLocale(url = '') {
  if (url) {
    return url.replace(/([a-z]{2}-[A-Z]{2}\/)/g, '');
  }
  return url;
}
